import { BankOutlined, IdcardOutlined, UserOutlined } from "@ant-design/icons";
export const SidebarItems = [
  {
    key: 1,
    icon: <UserOutlined />,
    label: "My profile",
    to: "/my-profile/summary",
    paths: ["my-profile"],
    name: "My profile",
    level: 1,
  },
  {
    key: 2,
    icon: <BankOutlined />,
    label: "Management units",
    to: "/units",
    paths: ["units"],
    name: "Management units",
    level: 1,
  },
  {
    key: 3,
    icon: <IdcardOutlined />,
    label: "Faculty profile",
    to: "/profiles",
    paths: ["profiles"],
    name: "Faculty profile",
    level: 1,
  },
];
